export default __webpack_public_path__ + "assets/download.cd420f76.svg";